import React from 'react'
import { compose } from 'redux'
import { onMount, modifyProps } from 'lp-utils'
import PropTypes from 'prop-types'
import { triggerResponsiveNav, venueClass } from 'utils'

const propTypes = {
  item: PropTypes.object.isRequired,
  classList: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,
}

function ResponsiveNavItem ({ item: { title, url, object, objectSlug }, classList, target, rel }) {
  return (
    <li className={ classList } >
      <a  className={ `responsive ${ object } ${ objectSlug } nav-logo-${ venueClass(title) }` } 
          href={ url } 
          target={ target }
          rel={ rel }>
        { title }
      </a>
    </li>
  )
}

ResponsiveNavItem.propTypes = propTypes

function modify({ targetVal }) {
  const linkTargetVal = targetVal ? targetVal : '_blank'
  const relVal = linkTargetVal === '_blank' ? 'noopener noreferrer' : ''

  return {
    target: linkTargetVal,
    rel: relVal,
  }
}

export default compose(
  onMount(triggerResponsiveNav),
  modifyProps(modify),
)(ResponsiveNavItem)